import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {Title} from '@angular/platform-browser';
import {ReplaySubject, Subject} from 'rxjs';
import {User} from '../../../models/user';
import {FormControl} from '@angular/forms';
import {TrackingLocation} from '../../../models/tracking-location';
import {UserTimeline} from '../../../models/user-timeline';
import {Market} from '../../../models/market';
import {MarketLevel} from '../../../models/market-level';
import {DatePipe} from '@angular/common';
import {MatPaginator, MatSelectChange, MatSort, MatTabChangeEvent} from '@angular/material';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITH_TIME, SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {takeUntil} from 'rxjs/internal/operators';
import swal from 'sweetalert2';
import {Endpoints} from '../../../config/endpoints';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from 'exceljs';
import * as fs from 'file-saver';
import { TitleBroadcastService } from 'app/services/title-broadcast.service';

@Component({
  selector: 'app-timeline-by-date-range',
  templateUrl: './timeline-by-date-range.component.html',
  styleUrls: ['./timeline-by-date-range.component.scss']
})
export class TimelineByDateRangeComponent implements OnInit {

    constructor( private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private titleService: Title,private titleBroadcastService: TitleBroadcastService  ) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('User Timeline By Date Range');
        this.loggedUser = auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach( marketLevel => {
            this.markets[ marketLevel.Rank ] = [];
            this.selectedMarket[ marketLevel.Rank ] = null;
        } );
    }

    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>( 1 );
    userFilter: FormControl = new FormControl();
    locationList: TrackingLocation[] = [];
    timelineList: UserTimeline[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    viewInOldFormat = false;
    displayedColumns = ['SN', 'From', 'To', 'Duration', 'Address', 'Distance', 'Interval'];

    market = new Market();
    user = new User();
    headers = [];
    headerValues = [];
    exportData = [];
    progress: number;
    showProgressBar = false;
    waitForProgress = true;
    totalPages = 0;
    datePipe = new DatePipe('en-US');
    selectedTab = 'map';

    @ViewChild( MatPaginator ) paginator: MatPaginator;
    @ViewChild( MatSort ) sort: MatSort;

    dataSource: BaseDatasourceService<UserTimeline>;

    filters = {
        'UserId'      : null,
        'FromDate': moment().format( SERVER_DATE_FORMAT_WITHOUT_TIME ),
        'ToDate'  : moment().format( SERVER_DATE_FORMAT_WITHOUT_TIME )
    };


    userType = 'ORGANIZATION_USER';

    private _unsubscribeAll: Subject<any>;

    // tslint:disable-next-line:typedef
    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.reloadDatatable();
        }
    }

    ngOnInit(): void {

        this.titleService.setTitle('User Timeline');

        this._getUserList();
        this.userFilter.valueChanges.pipe( takeUntil( this._unsubscribeAll ) ).subscribe( () => {
            if ( !this.userList ) {
                return;
            }

            const search = this.userFilter.value;
            if ( !search ) {
                this.filteredUserList.next( this.userList.slice() );
                return;
            }

            this._getUserList(search);
            this.filteredUserList.next( this.userList.filter( user => user.UserName.toLowerCase().indexOf( search.toLowerCase() ) > -1
            ) );
        } );
        this.dataSource = new BaseDatasourceService<UserTimeline>( this.service );
    }

    ngAfterViewInit(): void {
        this.service.getMarketList( {
            MarketLevelId: this.marketLevels[ 0 ].Id,
            Active       : true
        } ).subscribe( marketListResponse => {
            this.markets[ 1 ] = marketListResponse;
        } );
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
            if ( this.selectedMarket[ i ] ) {
                marketIdList = [ this.selectedMarket[ i ].Id ];
                break;
            }
        }

        this.service.getUserList( {
            ResponseSize: 'MINIFY',
            UserType: this.userType,
            MarketIdList: marketIdList,
            SearchKey: search,
            PageNumber: 0,
            RecordsPerPage: 50
        } ).subscribe( userList => {
            this.userList = userList;
            this.filteredUserList.next( this.userList.slice() );
        } );
    }

    setFromDate( event ): void {
        this.filters.FromDate = moment( event.value ).format( SERVER_DATE_FORMAT_WITHOUT_TIME );
    }
    setToDate( event ): void {
        this.filters.ToDate = moment( event.value ).format( SERVER_DATE_FORMAT_WITHOUT_TIME );
    }

    _resetChildDropdowns( pParentRank: number ): void {
        this.marketLevels.forEach( marketLevel => {
            if ( marketLevel.Rank > pParentRank ) {
                this.selectedMarket[ marketLevel.Rank ] = null;
                this.markets[ marketLevel.Rank ] = [];
            }
        } );
    }

    populateChildrenMarkets( event: MatSelectChange ): void {
        const market: Market = event.value;
        if ( market ) {
            this._resetChildDropdowns( market.MarketRank );
            if ( this.marketLevels[ market.MarketRank ] ) {
                this.service.getMarketList( {
                    MarketLevelId : this.marketLevels[ market.MarketRank ].Id,
                    ParentMarketId: market.Id,
                    Active        : true
                } ).subscribe( marketListResponse => {
                    this.markets[ market.MarketRank + 1 ] = marketListResponse;
                } );
            }
        }
        else {
            this._resetChildDropdowns( parseInt( event.source.id.slice( 6 ), 10 ) );
        }
        this._getUserList();

    }

    userChangeListener(pEvent: MatSelectChange): void {
        if (pEvent.value){
            this.filters.UserId = pEvent.value.Id;
        }
        else {
            this.filters.UserId = null;
            this.user = new User();
        }
    }

    reloadDatatable(): void {
        if (!this.filters.UserId){
            swal('Wrong Input', 'Please select a user', 'warning');
            return;
        }
        this.dataSource.fetchRemoteData( Endpoints.timeline_by_date_range, this.filters );
    }

    prepareData(pItemList: UserTimeline[]): void{
        pItemList.forEach( (pItem, index) => {
            const array = [];
            array.push(index + 1);
            array.push(this.datePipe.transform(pItem.FromTime, 'dd-MMM-yyyy h:mm:ss a'));
            array.push(this.datePipe.transform(pItem.ToTime, 'dd-MMM-yyyy h:mm:ss a'));
            array.push(pItem.Duration ? pItem.Duration : 'Travelling');
            array.push(pItem.Lat);
            array.push(pItem.Lon);
            array.push(pItem.Address);
            array.push(pItem.DistanceInKm);
            array.push(pItem.Interval);
            this.exportData.push(array);
        });
    }

    prepareHeaders(): void {
        this.headers = [];
        this.headerValues = [];
        this.headers.push('From Date');
        this.headerValues.push(this.filters.FromDate);
        this.headers.push('To Date');
        this.headerValues.push(this.filters.ToDate);

        if (this.filters.UserId){
            this.headers.push('User');
            this.headerValues.push(this.user.UserName + '(' + this.user.UserCode + ')');
        }

        if (this.market.Id){
            this.headers.push('Market');
            this.headerValues.push(this.market.MarketName + '(' + this.market.MarketCode + ')');
        }

    }

    downloadReport(): void {

        let isSelected1: boolean;
        let isSelected: boolean;
        let fileType: string;
        let fileName = null;

        this.market = new Market();
        this.market.Id = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.market = this.selectedMarket[i];
                break;
            }
        }
        swal( {
            title: 'Download Report',
            html: '<div class="example-container"><mat-form-field style="border: 1px solid black;"><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="CSV" id="input1" name="filetype" checked> CSV' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="XLSX" id="input2" style="margin-left: 20px;"> XLSX ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton   : true,
            confirmButtonText  : 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                if (isSelected || isSelected1) {
                    swal.enableConfirmButton();
                    this.showProgressBar = true;
                } else {
                    swal.disableConfirmButton();
                }
                fileName = (<HTMLInputElement>document.getElementById('report')).value;
                if (isSelected) {
                    fileType = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (isSelected1) {
                    fileType = (<HTMLInputElement>document.getElementById('input2')).value;
                }


                const workbook: ExcelProper.Workbook = new Excel.Workbook();
                const worksheet = workbook.addWorksheet('Timeline');
                worksheet.addRow(['User Location Timeline By Date Range']);
                worksheet.addRow([]);

                this.prepareHeaders();
                worksheet.addRow(this.headers);
                worksheet.addRow(this.headerValues);
                worksheet.addRow([]);

                const headers = [];
                headers.push('SN', 'Start Time', 'End Time', 'Duration', 'Latitude', 'Longitude', 'Address', 'Distance(Km)', 'Interval');

                worksheet.addRow(headers);
                this.exportData = [];

                let itemList = [];
                this.service.postData(Endpoints.timeline_by_date_range, this.filters).subscribe( pResponse => {
                    itemList = pResponse['Data']['content'];
                    this.showProgressBar = false;
                    if (itemList) {
                        this.prepareData(itemList);
                    }

                    if (this.exportData.length > 0) {
                        this.exportData.forEach(pExport => {
                            worksheet.addRow(pExport).alignment = {wrapText: true};
                        });

                        if (!fileName) {
                            fileName = 'User Location Timeline By Date Range';
                        }
                        if (fileType == 'XLSX') {
                            workbook.xlsx.writeBuffer().then((data) => {
                                const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                fs.saveAs(blob, fileName + '.xlsx');

                            });
                        }

                        if (fileType == 'CSV') {
                            workbook.csv.writeBuffer().then((data) => {
                                const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                fs.saveAs(blob, fileName + '.csv');

                            });
                        }

                    } else {
                        swal('Message', 'No Data In This Range To Download');
                    }

                });
            },

            allowOutsideClick  : () => !swal.isLoading()
        } );

    }


}
